import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import Router from "./Router"

import 'bootstrap/dist/css/bootstrap.css';
import './resources/css/styles.css'
import './resources/css/vps.css'

import 'font-awesome/css/font-awesome.min.css';



const root = createRoot(document.getElementById("root"));
root.render(
  <StrictMode>
    <Router />
  </StrictMode>
);